import { Component, inject } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { SessionExpiryService } from './session-expiry.service';

@Component({
  selector: 'app-session-expiry-modal',
  standalone: true,
  templateUrl: './session-expiry-modal.component.html',
  styleUrl: './session-expiry-modal.component.scss',
})
export class SessionExpiryModalComponent {
  readonly sessionExpiry = inject(SessionExpiryService);
  private readonly authService = inject(AuthService);

  onStayLoggedIn(): void {
    if (this.sessionExpiry.isRefreshing()) {
      return;
    }
    this.sessionExpiry.setRefreshing(true);
    this.authService.extendSession().subscribe({
      next: (success) => {
        this.sessionExpiry.setRefreshing(false);
        if (!success) {
          this.authService.handleSessionExpired(
            'Unable to extend your session. Please sign in again.',
          );
        }
      },
      error: () => {
        this.sessionExpiry.setRefreshing(false);
        this.authService.handleSessionExpired(
          'Unable to extend your session. Please sign in again.',
        );
      },
    });
  }

  onLogout(): void {
    this.sessionExpiry.close();
    this.authService.logoutWithRevoke();
  }
}
